import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import recommendedAdTemplate from './preview-image-extension-column.pug';

export class PreviewImageExtensionColumn extends CampaignuiBaseColumn {
  constructor({
    scope,
    i18n,
    newI18n,
    deps,
  }) {
    const title = newI18n.getString(_TL_('Image extension'));

    super({
      name: 'PreviewImageExtension',
      property: 'PreviewImageExtension',
      title,
      sortable: false,
      type: 'string',
      helpId: 'pop_BA_CampaignGrids_AdExtensions',
      bodyClasses: ['suggested-image-extension-preview-column'],
      colClasses: ['mma-col-ads-preview'],
      helpAriaLabel: title,
    });

    this.scope = scope;
    this.i18n = i18n;
    this.newI18n = newI18n;
    this.deps = deps;
  }

  pickProperty(recommendation) {
    const opportunity = recommendation.Opportunities[0];
    const { OpportunityType } = opportunity;
    const { IsRecommendationGetShutterStockImageFromUXEnabled } = this.deps.permissions;

    const {
      AlternativeText,
      DisplayText,
      FinalURL,
      StockImages,
      WebsiteImages,
    } = opportunity;

    let landscapeImageMediaUrl;

    if (!_.isEmpty(WebsiteImages) && !_.isEmpty(_.first(WebsiteImages).ImageURL)) {
      landscapeImageMediaUrl = _.first(WebsiteImages).ImageURL;
    } else if (
      !IsRecommendationGetShutterStockImageFromUXEnabled
      && !_.isEmpty(StockImages)
      && !_.isEmpty(_.first(StockImages).ThumbnailURL)) {
      landscapeImageMediaUrl = _.first(StockImages).ThumbnailURL;
    }

    const pickProperities = {
      DisplayText,
      AlternativeText,
      FinalURL,
      i18n: this.i18n,
      newI18n: this.newI18n,
      hasImages: !_.isEmpty(landscapeImageMediaUrl),
      landscapeImageMediaUrl,
      noImageText: this.newI18n.getString(_TL_('Image preview is not currently available. Please select the "+" thumbnail or the Add image extension button to add an image extension.')),
      IsRecommendationGetShutterStockImageFromUXEnabled,
    };

    return _.defaults({
      OpportunityType,
    }, pickProperities);
  }

  get template() { return recommendedAdTemplate; }
}
